import axios from 'axios';
import {WEATHER_IMAGE_API_URL, WEATHER_API_URL} from '../constant';

export class Weather {
  static async getWeatherInfo() {
    const position = await this.getCoordinates();
    let latitude = position.coords.latitude;
    let longitude = position.coords.longitude;
    return this.getWeather(longitude, latitude);
  }

  static getCoordinates() {
    return new Promise(function (resolve, reject) {
      navigator.geolocation.getCurrentPosition(resolve, reject);
    });
  }

  static async getWeather(longitude, latitude) {
    const API_KEY = process.env.REACT_APP_WEATHER_KEY;
    const res = await axios
      .get(
        `${WEATHER_API_URL}?lat=${latitude}&lon=${longitude}&appid=${API_KEY}&units=metric`,
      )
      .then(function (response) {
        console.log(response.data);
        return response.data;
      });
    return {
      temperature: res.main.temp,
      icon: `/assets/icon/${res.weather[0].icon}.png`,
      iconId: res.weather[0].icon,
    };
  }
}
